import React, { useState } from "react";
import ReactTable from "react-table";
import { Badge } from "reactstrap";
import EmpleadoBaja from "../../../../types/EmpleadoBaja";
import BaseButtonWithIconAndTooltip from "../../../../toolkit/baseButtonWithIconAndTooltip";
import { faDownload, faUndo } from "@fortawesome/free-solid-svg-icons";
import { formatIsoDate } from "../../../helpers/formatters";

interface Props {
  empleados: EmpleadoBaja[];
  loading: boolean;
  onDescargarReporte: (idEmpleado: number, tipoEmpleado: string) => void;
  onRevertirPago: (idEmpleado: number, tipoEmpleado: string) => void;
  deletingPagoAnticipado: boolean;
}

export const PagoAnticipadoTable = React.memo<Props>(
  ({
    empleados,
    loading,
    onDescargarReporte,
    onRevertirPago,
    deletingPagoAnticipado
  }) => {
    const [downloadingId, setDownloadingId] = useState<number | null>(null);

    const handleDescargar = (idEmpleado: number, tipoEmpleado: string) => {
      setDownloadingId(idEmpleado);
      onDescargarReporte(idEmpleado, tipoEmpleado);
      setTimeout(() => setDownloadingId(null), 3000);
    };

    const columns = [
      {
        Header: "Club",
        accessor: "nombreClub",
        headerClassName: "text-left",
        width: 100,
        Cell: ({ value }: any) => `Club ${value}`
      },
      {
        Header: "No. Emp.",
        accessor: "numeroEmpleado",
        headerClassName: "text-left",
        width: 88
      },
      {
        Header: "Empleado",
        accessor: "nombreEmpleado",
        headerClassName: "text-left"
      },
      {
        Header: "Tipo",
        accessor: "tipoEmpleado",
        headerClassName: "text-left",
        width: 150,
        Cell: ({ value }: any) =>
          value === "ASESOR" ? "Asesor" : "Líder Comercial"
      },
      {
        Header: "Fecha de Baja",
        accessor: "fechaBaja",
        headerClassName: "text-left",
        width: 128,
        Cell: ({ value }: any) => formatIsoDate(value) || "Sin fecha de baja"
      },
      {
        Header: "Acciones",
        width: 120,
        Cell: ({ original }: any) => {
          const disabled =
            downloadingId === original.idEmpleado || deletingPagoAnticipado;
          const color = disabled ? "#ccc" : "#000";

          return (
            <>
              <BaseButtonWithIconAndTooltip
                id={`descargar${original.idEmpleado}`}
                icon={faDownload}
                color={
                  downloadingId === original.idEmpleado ? "#17a2b8" : color
                }
                tooltipTitle="Descargar Reporte"
                onClick={() =>
                  disabled ||
                  handleDescargar(original.idEmpleado, original.tipoEmpleado)
                }
              />
              <BaseButtonWithIconAndTooltip
                id={`revertir${original.idEmpleado}`}
                icon={faUndo}
                color={deletingPagoAnticipado ? "#ffc107" : color}
                tooltipTitle="Revertir Pago"
                onClick={() =>
                  disabled ||
                  onRevertirPago(original.idEmpleado, original.tipoEmpleado)
                }
              />
            </>
          );
        }
      }
    ];

    return (
      <div className="mt-4">
        <ReactTable
          data={empleados || []}
          columns={columns}
          loading={loading}
          showPagination={false}
          pageSize={(empleados || []).length || 5}
          minRows={5}
          noDataText="No se encontraron empleados dados de baja en el periodo seleccionado"
          loadingText="Cargando empleados dados de baja..."
          className="-striped -highlight"
        />
      </div>
    );
  }
);
